<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return {

    };
  },
  methods: {

  },

  created() {
    console.log(111)
  },
  globalData: {
    oldUrl: 'http://global.aitrans.org.cn/old',
  },
};
</script>
<style >
.el-loading-spinner .circular {
  width: 42px;
  height: 42px;
  animation: loading-rotate 2s linear infinite;
  display: none;
}

.el-loading-spinner {
  background: url('./assets/loading3.gif') no-repeat;
  background-size: 38px 38px;
  width: 100%;
  height: 100%;
  position: relative;
  top: 50%;
  left: 50%;
  text-align: left;
}

.el-loading-spinner .el-icon-loading {
  display: none;
}

.el-loading-spinner .el-loading-text {
  color: #fff !important;
  font-size: 19px !important;
  margin: 0 !important;
  position: absolute;
  top: 0;
  left: -80px;
}

.el-loading-parent--hidden {
  overflow: auto !important;
}

.c-p {
  cursor: pointer;
}

.el-dialog__header {
  background-color: #cbcbcb;
  padding: 15px 20px !important;
}
.el-dialog__headerbtn {
  top: 15px;
}
</style>
